import { Header } from "@/components/landing/Header";
import { UrgencyStrip } from "@/components/landing/UrgencyStrip";
import { Hero } from "@/components/landing/Hero";
import { UrgencySection } from "@/components/landing/UrgencySection";
import { Benefits } from "@/components/landing/Benefits";
import { Services } from "@/components/landing/Services";
import { Portfolio } from "@/components/landing/Portfolio";
import { Testimonials } from "@/components/landing/Testimonials";
import { LeadForm } from "@/components/landing/LeadForm";
import { CtaSection } from "@/components/landing/CtaSection";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import { StickyCtas } from "@/components/landing/StickyCtas";

function App() {
    return (
        <div className="min-h-screen bg-[#FDFBF7] pb-[56px] font-sans text-[#2C2A29] antialiased md:pb-0">
            <UrgencyStrip />
            <Header />
            <main>
                <Hero />
                <UrgencySection />
                <Benefits />
                <Services />
                <Portfolio />
                <Testimonials />
                <LeadForm />
                <CtaSection testIdPrefix="midcta" />
                <Contact />
                <CtaSection
                    testIdPrefix="finalcta"
                    title="Don't miss your wedding date – Book now"
                    subtitle="Slots for this wedding season are filling fast. Call or WhatsApp now to secure your muhurtham date."
                    dark
                />
            </main>
            <Footer />
            <StickyCtas />
        </div>
    );
}

export default App;
